<template>
    <widget-wrapper
    hideRedirectIcon
    extraClass="merchant"
    :variant="variant"
    :title="t('home.widgets.merchant.title')"
    @redirectToFeature="navigateByName(routeList.COMPANY_PAYMENTS_BAI_PAGA_MERCHANT_NAME)">
        <div class="content-wrapper" :class="{'mobile': getMobileAppState}">
            <!-- Message -->
            <div class="message">{{t('home.widgets.merchant.message')}}</div>
            <!-- Icon -->
            <div class="icon-button-wrapper">
                <!-- Icon -->
                <icon-company-payments-merchant/>
                <!-- Button -->
                <button-primary
                icon="arrow-right-full"
                iconPosition="right"
                buttonSize="small"
                :label="t('home.widgets.merchant.registMerchant')"
                @clicked="navigateByName(routeList.COMPANY_PAYMENTS_BAI_PAGA_MERCHANT_NAME)"/>
            </div>
        </div>
    </widget-wrapper>
</template>

<script setup>
import WidgetWrapper from '@/components/features/home/WidgetWrapper'
import ButtonPrimary from '@/components/generic/buttons/Primary'
import IconCompanyPaymentsMerchant from '@/assets/icons/illustrations/company-payments-merchant.svg?inline'
/* Vue & Assets */
import { navigateByName } from '@/router/helpers/navigation'
import { routeList } from '@/router/helpers/routes'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const { getMobileAppState } = mapGetters()

</script>

<style lang="scss" scoped>
.content-wrapper {
    width: 100%;
    height: 100%;
    padding: 16px 16px 0 16px;

    display: flex;
    flex-direction: column;

    .message {
        width: 100%;
        margin-bottom: 24px;

        @include H7-Regular;
        color: var(--secondary-dark-2);
        line-height: 16px;
    }

    .icon-button-wrapper {
        width: 100%;
        height: 100%;

        display: flex;
        justify-content: space-between;
        align-items: flex-end;

        svg {
            width: 152px;
            height: 152px;
        }
    }

    &.mobile {
        .icon-button-wrapper {
            svg {
                width: 112px;
                height: 112px;
            }
        }
    }
}
</style>
